/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactHtmlParser from 'react-html-parser';
import Grid from '@material-ui/core/Grid';

const styles = (theme) => ({
    container: {
        padding: '20px 10%',
        textAlign: 'center',
    },
    header: {
        color: `${theme.palette.primary.main} !important`,
        textAlign: 'center',
    },
    message: {
        padding: '20px 0px',
        fontSize: '20px !important',
    },
});

const outageText = {
    header: 'Planned Maintenance in Progress',
    message: 'We apologize for the inconvenience, but we’re performing some maintenance. We are still delivering smiles as scheduled and will resume our notifications soon. Please check back shortly to check your order status and make modifications.',
};

const OrderTrackingOutage = ({ classes }) => (
    <Grid className={classes.container} container>
        <Grid xs={12}>
            <Typography
                variant="h1"
                className={classes.header}
                align="center"
            >
                {ReactHtmlParser(outageText.header)}
            </Typography>
        </Grid>
        <Grid xs={12}>
            <Typography
                className={classes.message}
            >
                {ReactHtmlParser(outageText.message)}
            </Typography>
        </Grid>
    </Grid>
);

OrderTrackingOutage.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(OrderTrackingOutage);
